// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1HNF0","title":"FrontImage_title__3Wsn6"};